import { SelectionTeamActionType } from "../Constants/SelectionTeamActionType";

export const setSelectedTeams = (selectedTeams) => {
	return {
		type: SelectionTeamActionType.SET_SELECTED_TEAMS,
		payload: selectedTeams,
	};
};
